export default "<ion-app>\n  <amplify-authenticator>\n  <div>\n    <ion-router-outlet></ion-router-outlet>\n  </div>\n</amplify-authenticator>\n\n</ion-app>\n";